var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "error text-center py-5",
    class: [_vm.backgroundError, {
      lazyload: _vm.error.statusCode === 500
    }],
    attrs: {
      "data-bgset": _vm.error.statusCode === 500 ? 'https://cdn.maisonsdumonde.com/medias/global/pattern-2.png' : false
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content row align-items-center position-relative"
  }, [_c('div', {
    staticClass: "desc col-md-7 position-relative"
  }, [_c('h1', {
    staticClass: "valentine mb-2",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "mb-4",
    domProps: {
      "textContent": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('nuxt-link', {
    staticClass: "btn btn-dark mt-1",
    attrs: {
      "to": _vm.url
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t(_vm.error.fromReverse ? 'backAccountLabel' : 'button')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 offset-3 col-sm-4 offset-sm-4 col-md-5 offset-md-0 col-lg-4 col-xl-3 mt-3 mt-md-0"
  }, [_c('img', {
    staticClass: "lazyload img-fluid",
    attrs: {
      "data-srcset": _vm.image,
      "data-sizes": "auto",
      "alt": ""
    }
  })]), _vm._v(" "), _vm.error.statusCode === 404 ? _c('div', {
    staticClass: "anim col-12 position-absolute pt-5"
  }, [_c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_c('mdm-icon', {
    staticClass: "d-block bounce position-absolute",
    attrs: {
      "name": "boule-paille",
      "size": "100"
    }
  })], 1)]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };